<script setup lang="ts">
import { onMounted, unref, watch } from 'vue';

import { InputDebounced } from '#public_ts/components';

import { formUrl, useGlobalSeacrh } from './util';

const props = defineProps<{
    toggleButton?: boolean;
}>();

const { toggleMenuPanelsGlobal, searchText, filteredPanels } = useGlobalSeacrh();

const ROOT = __ROOT__;

function jumpToFirstForm() {
    if(!unref(searchText)) return;
    const firstForm = unref(filteredPanels)[0]?.panel[0];
    if(firstForm) {
        window.location.href = formUrl(firstForm.path);
    }
}

watch(searchText, () => {
    const search = unref(searchText);
    try {
        const storage = window.sessionStorage || window.localStorage;
        if(storage) {
            storage.setItem('menu-panels-search', search);
        }
    } catch(err) { /**/ }
});

onMounted(() => {
    try {
        const storage = window.sessionStorage || window.localStorage;
        if(storage) {
            const search = storage.getItem('menu-panels-search');
            if(search && (typeof (search) == 'string')) {
                searchText.value = search;
            }
        }
    } catch(err) { /**/ }
});
</script>

<template>
    <li class="header-search-form">
        <div class="input-group">
            <span class="input-group-addon">
                <a class="header-search-form-home-logo" :href="`${ROOT}Enrollment/index.shtml`">
                    <span
                        style="font-size:1.2em;"
                        class="bi bi-house"
                    />
                </a>
                <a :href="`${ROOT}Enrollment/index.shtml`" class="header-search-form-compact-logo" />
            </span>
            <span class="menu-panels-search-lbl" @click="jumpToFirstForm" />
            <InputDebounced
                id="menu-panels-search"
                v-model="searchText"
                class="form-control"
                title="Ricerca"
                @enter="jumpToFirstForm"
            />
            <span v-if="props.toggleButton" class="input-group-addon hidden_xl_gr">
                <a
                    id="menu-panels-toggle"
                    href="javascript:void(0);"
                    title="Toggle all panels"
                    @click.stop.prevent="toggleMenuPanelsGlobal = !toggleMenuPanelsGlobal"
                >
                    <span
                        style="font-size:1.2em;"
                        class="bi"
                        :class="toggleMenuPanelsGlobal ? 'bi-chevron-bar-down' : 'bi-chevron-bar-up'"
                    />
                </a>
            </span>
        </div>
    </li>
</template>
